import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PiPenNibLight } from 'react-icons/pi';
import { CiClock2 } from 'react-icons/ci';
import ButtonComponent from '../../General/Button';
import { RiComputerLine } from 'react-icons/ri';
import { AiOutlineDelete } from 'react-icons/ai';
import { PiNotePencilLight, PiBuildingsLight } from 'react-icons/pi';
import { FiFolderPlus } from 'react-icons/fi';
import { CiGrid41 } from 'react-icons/ci';
import { GoCalendar } from 'react-icons/go';
import { FiUsers } from 'react-icons/fi';
import { FiDroplet } from 'react-icons/fi';
import { Avatar, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Chip } from '@nextui-org/react';
import { deleteProject } from '../../../services/projects';
import { Notify } from 'notiflix';
import { Loading } from 'notiflix/build/notiflix-loading-aio';
import RequestPopupComponent from '../../Sidebar/RequestPopup';
import ThemePopupComponent from '../../Sidebar/ThemePopup';
import EditPopupComponent from '../../Sidebar/EditPopup';
import PAsideComponent from '../PAsideComponent';
import { getOrganizations, formatOrganizationFromApi, addProjectToOrganization } from '../../../services/organizations';

const PanelHpComponent = ({ projectData, timelineData, usersData, projectId }) => {
  const navigate = useNavigate();
  
  // Proje slug'ını al
  const projectSlug = projectId || projectData?.pslug || projectData?.id || 'proje-slug'
  
  // Admin kontrolü - userstatus 11 ise admin
  const isAdmin = projectData?.userstatus === 11
  
  const [isRequestPopupOpen, setIsRequestPopupOpen] = useState(false)
  const [isThemePopupOpen, setIsThemePopupOpen] = useState(false)
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false)
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false)
  const [isAddToOrgOpen, setIsAddToOrgOpen] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [projectOrganizations, setProjectOrganizations] = useState([])
  const [orgsLoading, setOrgsLoading] = useState(false)
  const [selectedOrgId, setSelectedOrgId] = useState(null)
  const [adding, setAdding] = useState(false)

  // Backend'den gelen proje verisinde organizasyon(lar) varsa doğrudan göster
  useEffect(() => {
    const singleOrg = projectData?.organization
    const fromBackend = projectData?.organizations || projectData?.organizations_projects
    if (singleOrg && singleOrg.id && singleOrg.title) {
      setProjectOrganizations([{ id: singleOrg.id, title: singleOrg.title, slug: singleOrg.slug }])
      return
    }
    if (Array.isArray(fromBackend) && fromBackend.length > 0) {
      // Backend organizasyonları normalize et (id, title, slug)
      const normalized = fromBackend.map((o) => ({
        id: o.id ?? o.organization_id ?? o.org_id ?? o?.organization?.id,
        title: o.title ?? o.organization_title ?? o?.organization?.title,
        slug: o.slug ?? o.organization_slug ?? o?.organization?.slug
      })).filter((o) => o.id && o.title)
      setProjectOrganizations(normalized)
    }
  }, [projectData])

  const openRequestPopup = () => {
    setIsRequestPopupOpen(true)
    
  }

  const openThemePopup = () => {
    setIsThemePopupOpen(true)
  }

  const openEditPopup = () => {
    setIsEditPopupOpen(true)
  }
  const openDeletePopup = () => {
    setIsDeletePopupOpen(true)
  }

  const openAddToOrganization = async () => {
    setIsAddToOrgOpen(true)
    try {
      setOrgsLoading(true)
      const list = await getOrganizations()
      const formatted = list.map(formatOrganizationFromApi)
      setOrganizations(formatted)
      // Projenin bulunduğu organizasyonları belirle
      const belongs = formatted.filter((org) => {
        const projs = org.projects || []
        return projs.some((p) => {
          const pid = p.id ?? p.project_id
          const pslug = p.pslug ?? p.slug
          return (
            (projectData?.id && parseInt(pid) === parseInt(projectData.id)) ||
            (projectData?.pslug && pslug === projectData.pslug) ||
            (projectSlug && pslug === projectSlug)
          )
        })
      })
      setProjectOrganizations(belongs)
    } catch (e) {
      Notify.failure('Organizasyonlar yüklenemedi')
    } finally {
      setOrgsLoading(false)
    }
  }

  const handleDeleteProject = async () => {
    try {
      Loading.pulse('Proje siliniyor...');
      
      const response = await deleteProject(projectSlug);
      
      if (response.message) {
        Notify.success('Proje başarıyla silindi!', { position: 'right-bottom' });
        
        // Projeler sayfasına yönlendir
        setTimeout(() => {
          navigate('/projects');
        }, 1500);
      }
    } catch (error) {
      console.error('Proje silme hatası:', error);
      
      if (error.response?.status === 404) {
        Notify.failure('Proje bulunamadı veya yetkiniz yok!', { position: 'right-bottom' });
      } else if (error.response?.status === 500) {
        Notify.failure('Silme işlemi başarısız!', { position: 'right-bottom' });
      } else {
        Notify.failure('Proje silinirken bir hata oluştu!', { position: 'right-bottom' });
      }
    } finally {
      Loading.remove();
      setIsDeletePopupOpen(false);
    }
  }

  const closePopups = () => {
    setIsRequestPopupOpen(false)
    setIsThemePopupOpen(false)
    setIsEditPopupOpen(false)
    setIsDeletePopupOpen(false)
    setIsAddToOrgOpen(false)
  }

  const handleAddProjectToOrganization = async () => {
    if (!selectedOrgId) {
      Notify.warning('Lütfen bir organizasyon seçin')
      return
    }
    // Zaten bu organizasyonda mı?
    const selectedOrg = organizations.find((o) => String(o.id) === String(selectedOrgId))
    if (selectedOrg) {
      const alreadyIn = (selectedOrg.projects || []).some((p) => {
        const pid = p.id ?? p.project_id
        const pslug = p.pslug ?? p.slug
        return (
          (projectData?.id && parseInt(pid) === parseInt(projectData.id)) ||
          (projectData?.pslug && pslug === projectData.pslug) ||
          (projectSlug && pslug === projectSlug)
        )
      })
      if (alreadyIn) {
        Notify.warning('Proje zaten bu organizasyonda')
        return
      }
    }
    try {
      setAdding(true)
      await addProjectToOrganization(parseInt(selectedOrgId), parseInt(projectData?.id))
      Notify.success('Proje organizasyona eklendi')
      setIsAddToOrgOpen(false)
      setSelectedOrgId(null)
      // Listeyi güncelle
      if (selectedOrg) {
        setProjectOrganizations((prev) => {
          const exists = prev.some((o) => parseInt(o.id) === parseInt(selectedOrg.id))
          return exists ? prev : [...prev, selectedOrg]
        })
      }
    } catch (e) {
      const message = e?.response?.data?.message || 'İşlem başarısız. Sahiplik yetkilerinizi kontrol edin.'
      Notify.failure(message)
    } finally {
      setAdding(false)
    }
  }

  return (
    <div className="border dark:border-dark-300 w-full border-gray-200  bg-white  dark:bg-dark-300  my-3  p-[5px] rounded-md">
      <div className="flex flex-col">
        <div className="p-6 flex justify-between">
          <div>
            <h1 className="w-[200px] text-gray-700 dark:text-darkWhite-300 text-xl font-semibold">{projectData.pname}</h1>
            <p className="opacity-50  text-md ">{projectData.pfirm}</p>
            {(projectData?.organization && projectData.organization.title) || projectOrganizations.length > 0 ? (
              <p className="text-blue-600 dark:text-blue-300 text-md flex items-center gap-2 ">
                <PiBuildingsLight size={16} className="opacity-80" />
                <span className="font-semibold">{projectData?.organization?.title || projectOrganizations.map(o => o.title).join(', ')}</span>
              </p>
            ) : null}
          </div>
          {/* Admin Butonları - Sadece admin kullanıcılar görebilir */}
          {isAdmin && (
            <div className="flex space-x-3">
              <button
                onClick={openRequestPopup}
                className="group relative p-3 rounded-lg bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:border-blue-300 dark:hover:border-blue-600 transition-all duration-200 shadow-sm hover:shadow-md"
                title="Kullanıcı İstekleri"
              >
                <FiUsers size={18} className="text-gray-600 dark:text-gray-300 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors" />
              </button>
              
              <button
                onClick={openThemePopup}
                className="group relative p-3 rounded-lg bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-300 hover:bg-purple-50 dark:hover:bg-purple-900/20 hover:border-purple-300 dark:hover:border-purple-600 transition-all duration-200 shadow-sm hover:shadow-md"
                title="Tema Ayarları"
              >
                <RiComputerLine size={18} className="text-gray-600 dark:text-gray-300 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors" />
              </button>
              
              <button
                onClick={openEditPopup}
                className="group relative p-3 rounded-lg bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-300 hover:bg-orange-50 dark:hover:bg-orange-900/20 hover:border-orange-300 dark:hover:border-orange-600 transition-all duration-200 shadow-sm hover:shadow-md"
                title="Projeyi Düzenle"
              >
                <PiNotePencilLight size={18} className="text-gray-600 dark:text-gray-300 group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors" />
              </button>
              
              <button
                onClick={openDeletePopup}
                className="group relative p-3 rounded-lg bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-300 hover:bg-red-50 dark:hover:bg-red-900/20 hover:border-red-300 dark:hover:border-red-600 transition-all duration-200 shadow-sm hover:shadow-md"
                title="Projeyi Sil"
              >
                <AiOutlineDelete size={18} className="text-gray-600 dark:text-gray-300 group-hover:text-red-600 dark:group-hover:text-red-400 transition-colors" />
              </button>

              <button
                onClick={openAddToOrganization}
                className="group relative p-3 rounded-lg bg-white dark:bg-dark-300 border border-gray-200 dark:border-dark-300 hover:bg-orange-50 dark:hover:bg-orange-900/20 hover:border-orange-300 dark:hover:border-orange-600 transition-all duration-200 shadow-sm hover:shadow-md"
                title="Organizasyona Ekle"
              >
                <FiFolderPlus size={18} className="text-gray-600 dark:text-gray-300 group-hover:text-orange-600 dark:group-hover:text-orange-400 transition-colors" />
              </button>
            </div>
          )}
        </div>

        <div className="m-4 flex">
          <p className="w-full opacity-50 text-md">{projectData.pdesc}</p>
          <div className="flex flex-row justify-between">
            {/* <img src="../../assets/heypena.png" alt="" className="h-[40px] w-[40px] rounded-full object-center border-3 bg-stone-100" />
            <button className="flex rounded-3xl bg-stone-100 h-[40px] w-[50px] border-1 ">
              <Link to="/projects/crew" className="flex dark:text-dark-300">
                <FiUsers className="text-center text-[20px] opacity-50 m-2" />
              </Link>
            </button> */}
            {usersData && usersData.slice(0, 5).map((item, index) => {
              // Kullanıcı ismini al (ufullname varsa kullan, yoksa varsayılan)
              const userName = item.ufullname || item.name || 'K';
              const firstLetter = userName.charAt(0).toUpperCase();
              
              return (
                <Link key={index} to="#" className="flex dark:text-dark-300 -ml-3">
                  <Avatar
                    src={item.uimg !== null ?  item.uimg  : null}
                    name={firstLetter}
                    className="border-[1px] bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300"
                    classNames={{
                      base: "bg-gray-200 dark:bg-gray-600",
                      name: "text-gray-700 dark:text-gray-300 font-semibold"
                    }}
                  />
                </Link>
              );
            })}
          </div>
        </div>

        <div className="w-full border-t border-zinc-300 "></div>
        <div className="lg:flex lg:justify-between p-4 mr-8 grid grid-cols-2 gap-5 mx-10">
          <div className="">
            <PiPenNibLight className="fill-[#dc2626] dark:fill-[#797BF2]" size={25} />
            <h2 className="mt-3 text-gray-700 dark:text-darkWhite-300 text-sm font-semibold">Proje Alanı</h2>
            <p className="text-xs opacity-50">Yazılım</p>
          </div>
          <div>
            <CiClock2 className="fill-[#dc2626] dark:fill-[#797BF2]" size={25} />
            <h2 className="mt-3 text-gray-700 dark:text-darkWhite-300 text-sm font-semibold">Oluşturulma Tarihi</h2>
            <p className="text-xs opacity-50">{projectData.created_at}</p>
          </div>
          <div>
            <GoCalendar className="fill-[#dc2626] dark:fill-[#797BF2]" size={25} />
            <h2 className="mt-3 text-gray-700 dark:text-darkWhite-300 text-sm font-semibold">Tahmini Bitiş Tarihi</h2>
            <p className="text-xs opacity-50">{projectData.penddate}</p>
          </div>
          <div>
            <CiGrid41 className="fill-[#dc2626] dark:fill-[#797BF2]" size={25} />
            <h2 className="mt-3 text-gray-700 dark:text-darkWhite-300 text-sm font-semibold">Proje Bütçesi</h2>
            <p className="text-xs opacity-50">{projectData.pbudget}</p>
          </div>
        </div>

        <div className="w-full border-t border-zinc-300 p-3 "></div>
        <div className="p-6 text-xs">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Sol Kolon - Son Aktivite'ler */}
            <div className="order-1 lg:order-1">
              <h2 className=" text-red-600 dark:text-violet-300 text-[11px] font-semibold">SON AKTİVİTELER</h2>
              <div className="mt-6">
                {timelineData && timelineData.length > 0 ? (
                  timelineData.slice(0, 3).map((activity, index) => (
                    <div key={index} className="mt-6 flex">
                      <FiDroplet color="#5eead4" className="mr-3 bg-teal-100 text-4xl rounded-full p-3" />
                      <div>
                        <p className="text-gray-700 dark:text-gray-300 text-sm">
                          {activity.description || activity.message || 'Aktivite gerçekleşti'}
                        </p>
                        <p className="text-gray-500 dark:text-gray-400 text-xs mt-1">
                          {activity.created_at || activity.timestamp || 'Tarih bilgisi yok'}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="mt-6 flex items-center justify-center py-8">
                    <div className="text-center">
                      <FiDroplet color="#9ca3af" className="mx-auto mb-3 bg-gray-100 dark:bg-gray-700 text-4xl rounded-full p-3" />
                      <p className="text-gray-500 dark:text-gray-400 text-sm">Şimdilik aktivite yok</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Sağ Kolon - İstatistik Paneli */}
            <div className="order-2 lg:order-2">
              <PAsideComponent projectId={projectId} projectData={projectData} />
            </div>
          </div>
        </div>
        {/* Admin Popup'ları - Sadece admin kullanıcılar görebilir */}
        {isAdmin && (
          <>
            {isRequestPopupOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center">
                <div 
                  className="absolute inset-0 bg-black bg-opacity-50" 
                  onClick={closePopups}
                ></div>
                <div className="relative z-10">
                  <RequestPopupComponent closePopup={setIsRequestPopupOpen} show={isRequestPopupOpen} projectSlug={projectSlug} />
                </div>
              </div>
            )}
            
            {isThemePopupOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center">
                <div 
                  className="absolute inset-0 bg-black bg-opacity-50" 
                  onClick={closePopups}
                ></div>
                <div className="relative z-10">
                  <ThemePopupComponent closePopup={setIsThemePopupOpen} show={isThemePopupOpen} />
                </div>
              </div>
            )}
            
            {isEditPopupOpen && (
              <div className="fixed inset-0 z-50 flex items-center justify-center">
                <div 
                  className="absolute inset-0 bg-black bg-opacity-50" 
                  onClick={closePopups}
                ></div>
                <div className="relative z-10">
                  <EditPopupComponent closePopup={setIsEditPopupOpen} show={isEditPopupOpen} projectsData={projectData} projectSlug={projectSlug} />
                </div>
              </div>
            )}
            
            {/* Proje Silme Modal */}
            <Modal
              isOpen={isDeletePopupOpen}
              onClose={() => setIsDeletePopupOpen(false)}
              size="md"
              classNames={{
                base: "bg-white dark:bg-dark-300",
                header: "border-b border-gray-200 dark:border-gray-600",
                body: "py-6",
                footer: "border-t border-gray-200 dark:border-gray-600"
              }}
            >
              <ModalContent>
                <ModalHeader className="flex flex-col gap-1">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-red-100 dark:bg-red-900/30 rounded-lg">
                      <AiOutlineDelete className="text-red-600 dark:text-red-400" size={20} />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                      Projeyi Sil
                    </h3>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <div className="text-center">
                    <p className="text-gray-600 dark:text-gray-400 mb-4">
                      Bu projeyi silmek istediğinizden emin misiniz?
                    </p>
                    <div className="p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                      <h4 className="font-medium text-gray-900 dark:text-white mb-2">
                        {projectData?.pname || 'Proje'}
                      </h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {projectData?.pdesc || 'Proje açıklaması'}
                      </p>
                    </div>
                    <p className="text-sm text-red-600 dark:text-red-400 mt-4">
                      Bu işlem geri alınamaz ve proje kalıcı olarak silinecektir.
                    </p>
                  </div>
                </ModalBody>
                <ModalFooter className="flex justify-end space-x-2">
                  <Button
                    variant="light"
                    onPress={() => setIsDeletePopupOpen(false)}
                  >
                    İptal
                  </Button>
                  <Button
                    color="danger"
                    onPress={handleDeleteProject}
                    startContent={<AiOutlineDelete size={16} />}
                  >
                    Projeyi Sil
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>

            {/* Organizasyona Ekle Modal */}
            <Modal
              isOpen={isAddToOrgOpen}
              onClose={() => setIsAddToOrgOpen(false)}
              size="md"
              classNames={{
                base: "bg-white dark:bg-dark-300",
                header: "border-b border-gray-200 dark:border-gray-600",
                body: "py-6",
                footer: "border-t border-gray-200 dark:border-gray-600"
              }}
            >
              <ModalContent>
                <ModalHeader className="flex flex-col gap-1">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-orange-100 dark:bg-orange-900/30 rounded-lg">
                      <RiComputerLine className="text-orange-600 dark:text-orange-400" size={20} />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                      Projeyi Organizasyona Ekle
                    </h3>
                  </div>
                </ModalHeader>
                <ModalBody>
                  {orgsLoading ? (
                    <div className="text-center text-gray-600 dark:text-gray-400">Yükleniyor...</div>
                  ) : (
                    <div className="space-y-3">
                      {organizations.length === 0 ? (
                        <div className="text-center text-gray-600 dark:text-gray-400">
                          Tanımlı organizasyon bulunamadı.
                        </div>
                      ) : (
                        <Select
                          label="Organizasyon Seçin"
                          placeholder="Bir organizasyon seçin"
                          selectedKeys={selectedOrgId ? [String(selectedOrgId)] : []}
                          onChange={(e) => setSelectedOrgId(e.target.value)}
                        >
                          {organizations.map((org) => (
                            <SelectItem key={String(org.id)} value={String(org.id)}>
                              {org.title}
                            </SelectItem>
                          ))}
                        </Select>
                      )}
                      {selectedOrgId && (() => {
                        const sel = organizations.find((o) => String(o.id) === String(selectedOrgId))
                        const already = sel ? (sel.projects || []).some((p) => {
                          const pid = p.id ?? p.project_id
                          const pslug = p.pslug ?? p.slug
                          return (
                            (projectData?.id && parseInt(pid) === parseInt(projectData.id)) ||
                            (projectData?.pslug && pslug === projectData.pslug) ||
                            (projectSlug && pslug === projectSlug)
                          )
                        }) : false
                        return already ? (
                          <div className="text-red-600 dark:text-red-400 text-sm">
                            Proje zaten bu organizasyonda.
                          </div>
                        ) : null
                      })()}
                    </div>
                  )}
                </ModalBody>
                <ModalFooter className="flex justify-end space-x-2">
                  <Button
                    variant="light"
                    onPress={() => setIsAddToOrgOpen(false)}
                  >
                    İptal
                  </Button>
                  <Button
                    className="bg-[#da402f] dark:bg-[#7375E1] text-white hover:bg-[#c73a2a] dark:hover:bg-[#6b5fd1]"
                    isDisabled={!selectedOrgId || adding || (() => {
                      const sel = organizations.find((o) => String(o.id) === String(selectedOrgId))
                      if (!sel) return false
                      return (sel.projects || []).some((p) => {
                        const pid = p.id ?? p.project_id
                        const pslug = p.pslug ?? p.slug
                        return (
                          (projectData?.id && parseInt(pid) === parseInt(projectData.id)) ||
                          (projectData?.pslug && pslug === projectData.pslug) ||
                          (projectSlug && pslug === projectSlug)
                        )
                      })
                    })()}
                    onPress={handleAddProjectToOrganization}
                  >
                    {adding ? 'Ekleniyor...' : 'Ekle'}
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </>
        )}
      </div>
    </div>
  )
}
export default PanelHpComponent
